import { apiPageBuilderHistory, PageBuilderModuleItemProps } from ".";
import { apiPageFindById } from "apis/page/find";
import { loading, init, PageBuilderState } from "store/page-builder";
import { apiLayoutFindById } from "apis/layout";
import { store } from "store";
import { uuid } from "utils";
import { writePageConfig } from "store/cache";

interface ApiPageBuilderInitInputProps {
    pageId: number;
    count?: boolean;
}

type ApiPageBuilderInitOutputProps = boolean;

export const apiPageBuilderInit = async (data: ApiPageBuilderInitInputProps): Promise<ApiPageBuilderInitOutputProps> => {
    store.dispatch(loading());
    let result: boolean = true;
    let dataInit: PageBuilderState = { uid: uuid(), loading: false, history: [], builder: {} }
    const pageRes = await apiPageFindById({ id: data.pageId, count: data.count });
    if (pageRes.status) {
        dataInit.page = pageRes.data.item;
        const builderRes = await apiPageBuilderHistory({ pageId: data.pageId, page: 1, pageSize: 10 });
        if (builderRes.status) {
            const builderActive = builderRes.data.active;
            if (builderActive?.layoutId) {
                const layoutRes = await apiLayoutFindById({ id: builderActive.layoutId });
                if (layoutRes.status) {
                    dataInit.builder = {
                        ...dataInit.builder,
                        layout: {
                            ...layoutRes.data.item,
                            content: convertContent(layoutRes.data.item.content, builderActive.modules)
                        },
                        modules: builderActive.modules
                    };
                }
                else {
                    result = false;
                }
            }
            dataInit.history = builderRes.data.list;
            dataInit._pagination = builderRes.data.pagination;
        }
        else {
            result = false;
        }
    }
    else {
        result = false;
    }
    store.dispatch(init(dataInit));
    store.dispatch(writePageConfig({ pageId: data.pageId, config: dataInit }));
    return result;
};

function convertContent(content: string, modules: PageBuilderModuleItemProps[] = []) {
    // parse content thành DOM
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");

    // lấy tất cả thẻ render
    const renders = doc.querySelectorAll("render[data-id]");

    renders.forEach(renderEl => {
        const uid = renderEl.getAttribute("data-id");

        // tìm các module có cùng uid
        const matched = modules.filter(t => t.uid === uid) as PageBuilderModuleItemProps[];

        // xoá nội dung cũ
        renderEl.innerHTML = "";

        // thêm module con
        matched
            .sort((a, b) => a.index - b.index) // sắp xếp tăng dần theo index
            .forEach(t => {
                const tpl = doc.createElement("module");
                tpl.setAttribute("data-id", t.moduleId?.toString());
                tpl.setAttribute("data-index", t.index.toString());
                renderEl.appendChild(tpl);
            });
    });

    // trả lại content
    return doc.body.innerHTML;
}